module.exports = __webpack_public_path__ + "static/media/solicitudesRoja.95f7d7d2.png";